@if (petData) {
  <div class="info">
    <div class="subscription">
      <span class="body-12">{{ getSubscriptionInterval() | translate }}:</span>
      <span class="subtitle-12">CHF&nbsp;{{ getSubscriptionCost() | number:'1.2-2' }}</span>
    </div>
    <div class="open">
      <p class="body-12">{{ 'invoice-list.open-amount' | translate }}: <span class="subtitle-12 primary">CHF&nbsp;{{ getOpenAmount() | number:'1.2-2' }}</span></p>
    </div>
  </div>
}

@for (year of invoiceYearList; track year) {
  <div class="year-item" [class.collapsed]="!year.expanded">
    <div class="year-title-container">
      <div class="year-title">
        <div class="year-title-text">
          <p class="body-12">{{ 'invoice-list.year-title' | translate: { year: year.year } }}</p>
        </div>
        <div class="year-title-icon" (click)="toggleYear(year)">
          <mat-icon svgIcon="expand-up" [class.down]="!year.expanded"></mat-icon>
        </div>
      </div>
    </div>
    @if (year.expanded) {
      <div class="invoice-list">
        @for (invoice of year.items; track invoice) {
          <div class="invoice-item" (click)="openInvoicePdf(invoice)">
            <div class="part left">
              <div class="invoice-number">
                <p class="subtitle-14">{{ 'invoice-list.invoice-number' | translate }} {{ invoice.invoiceNumber }}</p>
              </div>
              <div class="total-amount">
                <p class="body-12">{{ 'invoice-list.amount' | translate }} CHF {{ invoice.totalAmount | number:'2.2-2' }}</p>
              </div>
              <div class="invoice-date">
                <p class="body-12">{{ 'invoice-list.payable-until' | translate }} {{ parseDueDate(invoice.dueDate) | date: 'dd.MM.yyyy' }}</p>
              </div>
            </div>
            <div class="part right">
              <div class="status" [ngClass]="checkInvoiceStatus(invoice)">
                <p class="tag-12">{{ formatInvoiceStatus(invoice) | translate }}</p>
              </div>
              @if (invoice.bexio_pdf_available) {
                <button class="button icon-only pdf-action"
                  [disabled]="isDownloading(invoice)"
                  (click)="$event.stopPropagation(); openInvoicePdf(invoice)">
                  @if (isDownloading(invoice)) {
                    <mat-spinner diameter="18"></mat-spinner>
                  } @else {
                    <mat-icon svgIcon="download-light"></mat-icon>
                  }
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}

@if (invoiceYearList?.length === 0) {
  <div class="empty-state">
    <mat-icon>description</mat-icon>
    <p class="subtitle-14">{{ 'invoice-list.no-invoices' | translate }}</p>
  </div>
}
